var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrity1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10253_8555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3994 12C17.3994 11.839 17.3922 11.685 17.3778 11.524L18.7169 10.537C19.0048 10.327 19.084 9.935 18.904 9.627L17.5578 7.366C17.4715 7.21773 17.3318 7.1057 17.1657 7.05143C16.9996 6.99717 16.8188 7.00449 16.6579 7.072L15.1101 7.709C14.8437 7.527 14.5629 7.366 14.2677 7.233L14.059 5.616C14.0158 5.266 13.7062 5 13.3463 5H10.6609C10.2938 5 9.98422 5.266 9.94103 5.616L9.73225 7.233C9.43708 7.366 9.15631 7.527 8.88994 7.709L7.34212 7.072C7.01095 6.932 6.6222 7.058 6.44221 7.366L5.09596 9.634C4.91598 9.942 4.99518 10.327 5.28314 10.544L6.6222 11.531C6.59218 11.8453 6.59218 12.1617 6.6222 12.476L5.28314 13.463C4.99518 13.673 4.91598 14.065 5.09596 14.373L6.44221 16.634C6.6222 16.942 7.01095 17.068 7.34212 16.928L8.88994 16.291C9.15631 16.473 9.43708 16.634 9.73225 16.767L9.94103 18.384C9.98422 18.734 10.2938 19 10.6537 19H13.3391C13.699 19 14.0086 18.734 14.0518 18.384L14.2606 16.767C14.5557 16.634 14.8365 16.473 15.1029 16.291L16.6507 16.928C16.9818 17.068 17.3706 16.942 17.5506 16.634L18.8968 14.373C19.0768 14.065 18.9976 13.68 18.7097 13.463L17.3706 12.476C17.3922 12.315 17.3994 12.161 17.3994 12ZM12.0288 14.45C10.6394 14.45 9.50908 13.351 9.50908 12C9.50908 10.649 10.6394 9.55 12.0288 9.55C13.4182 9.55 14.5485 10.649 14.5485 12C14.5485 13.351 13.4182 14.45 12.0288 14.45Z",
    fill: "#013C66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Repeat group 1_inner",
    "data-figma-trr": "r6u4.9-0f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.9688,
    cy: 2.16797,
    r: 2,
    fill: "#F6948B"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Repeat%20group%201_inner",
    transform: "translate(16.349 -4.3807) rotate(60)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Repeat%20group%201_inner",
    transform: "translate(28.3173 7.58759) rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Repeat%20group%201_inner",
    transform: "translate(23.9366 23.9366) rotate(-180)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Repeat%20group%201_inner",
    transform: "translate(7.58759 28.3173) rotate(-120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Repeat%20group%201_inner",
    transform: "translate(-4.3807 16.349) rotate(-60)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10253_8555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrity1);
export default __webpack_public_path__ + "static/media/Integrity 1.a839d06005a974808fc30eeca90aad70.svg";
export { ForwardRef as ReactComponent };